import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserIdleModule } from 'angular-user-idle';
import { UiModule } from 'app/ui/ui.module';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
         MatSortModule, MatTableModule  } from "@angular/material";
import { csComponent } from 'app/cs/cs.component';
import { HomeComponent } from 'app/cs/views/home/home.component';
import { ClientHomeComponent } from 'app/cs/views/client-home/client-home.component';
import { ServiceComponent } from 'app/cs/views/service/service.component';
import { ContactComponent } from 'app/cs/views/contact/contact.component';
import { Global } from 'app/cs/service/Global';
import { AgGridModule } from "ag-grid-angular/main";
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { ConsigmentUploadService } from 'app/cs/service/consignment-upload.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DropDownEditor } from 'app/cs/views/drop-down-editor/drop.down.editor';
import { CSModalComponent } from 'app/cs/views/cs-modal/cs-modal.component';
import { ButtonRendererComponent } from 'app/cs/views/app-button/app-button.component';


@NgModule(
  {
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    NgxSpinnerModule,
    AgGridModule.withComponents( [DropDownEditor]),
    DropdownModule,
    MultiSelectModule,
    AccordionModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    UserIdleModule.forRoot({idle: 300, timeout: 30, ping: 1}),
    RouterModule.forRoot([
          { path: "",  redirectTo : "home", pathMatch: "full" },
          { path: "home", component: HomeComponent },
          { path: "main", component: ClientHomeComponent },
          { path: "contact",component: ContactComponent},
          { path: "service", component : ServiceComponent},

    ], { useHash: true }),
    UiModule
  ],

  declarations: [
    csComponent,
    HomeComponent,
    ClientHomeComponent,
    ServiceComponent,
    ContactComponent,
    DropDownEditor,
    CSModalComponent,
    ButtonRendererComponent
  ],

  entryComponents: [
    ButtonRendererComponent
  ],

  providers: [
    { provide: 'Window', useValue: window },
    ConsigmentUploadService,
    Global
  ],

  bootstrap: [
    csComponent
  ]
  
})
export class csModule {
  constructor() {
 
  }
}




// WEBPACK FOOTER //
// ./src/app/cs/cs.module.ts